/**
 * 사용자PC 기사관리 (/u/drivers) — 월 급여 정산 표(체크한 기사만 합계), 수주/발주 요약, 월 메모
 * ($j.Pages.Desktop.DriverManage / body data-page-name="DriverManage")
 *
 * 합계 재계산은 레거시(user_3000) 포팅이다 — 체크된 행의 TdX1~TdX10 칸 값을 더해 #LastLine 의 XTdX* 에 쓴다.
 * 금액 대신 '설정' 링크가 든 칸은 0 으로 센다.
 */
export default class DriverManage {
    initialize() {
        const $wrap = $('.dm-wrap');
        this.dt    = String($wrap.data('dt'));
        this.year  = $wrap.data('year');
        this.month = $wrap.data('month');

        $('#dmApply').on('click', () => this.applyMonth());
        $('#topChall').on('click', (e) => this.selectAll(e.currentTarget.checked));
        $('#cntTrContent').on('click', 'input.dm-chk', () => this.recount());
        // 급여명세서 — '자세히' 버튼과 기본급·고정차감 칸의 '설정' 링크
        $('#cntTrContent').on('click', '[data-detail]', (e) => {
            e.preventDefault();
            this.openPayroll($(e.currentTarget).data('detail'));
        });
        $('#memoSave').on('click', () => this.saveMemo());
        $('#memolistBody').on('click', '.memo-del', (e) => this.deleteMemo($(e.currentTarget).data('memo')));

        this.loadMemo();
    }

    /** 정산년월 적용 — 주소로 다시 연다 */
    applyMonth() {
        const ym = document.getElementById('salary_ym').value; // "YYYY-MM"
        if (!ym) return;
        const p = ym.split('-');
        location.href = '/u/drivers?salary_year=' + p[0] + '&salary_month=' + parseInt(p[1], 10);
    }

    /** 기사 급여명세서 팝업 (레거시 user_3000_userview*.php → /u/drivers/{num}/payroll) */
    openPayroll(num) {
        const adr = '/u/drivers/' + num + '/payroll?mode=pcmanager'
                  + '&salary_year=' + this.year + '&salary_month=' + this.month;
        window.open(adr, 'user_3000_userview', 'toolbar=no,status=no,width=600,height=1000,scrollbars=yes,resizable=yes,menubar=no').focus();
    }

    /* ---- 체크박스 기반 합계 실시간 재계산 (레거시 포팅) ---- */
    selectAll(on) {
        $('#cntTrContent tr').each(function () {
            if ((parseInt(this.getAttribute('data_rsno')) || 0) > 0) this.getElementsByTagName('input')[0].checked = on;
        });
        this.recount();
    }

    recount() {
        const sum = {};
        this.checkedRows().forEach((row) => {
            for (const key in row) sum[key] = (sum[key] || 0) + row[key];
        });
        let ok = 0;
        for (const key in sum) {
            document.getElementById('X' + key).innerHTML = $j.Common.Util.formatNumber(sum[key]);
            if (key !== 'TdX1' && key !== 'TdX9' && key !== 'TdX10') ok = parseInt(ok + sum[key]);
        }
        if (ok === 0) {
            $('#LastLine td[id^="XTdX"]').html('0');
            document.getElementById('TotdX11').innerHTML = 0;
        } else {
            document.getElementById('TotdX11').innerHTML = '수익 : ' + $j.Common.Util.formatNumber(parseInt(sum['TdX1'] - ok));
        }
    }

    /** 체크된 기사 행의 칸 값들 ({TdX1: n, …}) — 전체선택 칸도 여기서 맞춘다 */
    checkedRows() {
        const list = [];
        let unchecked = 0;
        $('#cntTrContent tr').each(function () {
            if ((parseInt(this.getAttribute('data_rsno')) || 0) <= 0) return;
            if (!this.getElementsByTagName('input')[0].checked) { unchecked++; return; }
            const vals = {};
            $(this).children('td[id^="TdX"]').each(function () {
                const html = this.innerHTML;
                let v = (html.indexOf('data-detail') >= 0 || html.indexOf('설정') > 0) ? 0 : parseInt(html.replace(/,/gi, ''));
                if (isNaN(v)) v = 0;
                vals[this.id] = v;
            });
            list.push(vals);
        });
        document.getElementById('topChall').checked = (unchecked === 0);
        return list;
    }

    /* ---- 메모 ajax ---- */
    loadMemo() {
        $.get('/u/ajax/drivers/memo', { dt: this.dt }, (res) => {
            const list = (res && res.list) || [];
            if (!list.length) {
                $('#memolistBody').html("<tr><td class='empty'>메모가 없습니다.</td></tr>");
                return;
            }
            $('#memolistBody').html(list.map((m) => {
                const dl = (m.datetime || '').substring(5, 16);
                return '<tr><td>' + $('<div>').text(m.memo).html()
                    + `<span class='memo-del' data-memo='${Number(m.num)}'>삭제</span></td>`
                    + `<td class='memo-dt'>${dl}</td></tr>`;
            }).join(''));
        }, 'json');
    }

    saveMemo() {
        const memo = $('#memoInput').val();
        if (memo.length < 1) { alert('메모를 입력해 주세요'); $('#memoInput').focus(); return; }
        const ym = $('#memo_ym').val(); // "YYYY-MM"
        if (!ym) { alert('년월을 선택해 주세요'); return; }
        $.post('/u/ajax/drivers/memo', { memo: memo, dt: ym.replace('-', '') }, () => {
            $('#memoInput').val(''); this.loadMemo();
        }, 'json');
    }

    deleteMemo(no) {
        if (!confirm('선택한 메모를 삭제할까요?')) return;
        $.post('/u/ajax/drivers/memo/delete', { num: no }, () => this.loadMemo(), 'json');
    }
}
